var map = {
	"./Documents.svg": "f46e",
	"./Documents2.svg": "507c",
	"./Group.svg": "cc9e",
	"./IconCancel": "5c27",
	"./IconCancel/": "5c27",
	"./IconCancel/IconCancel": "2470",
	"./IconCancel/IconCancel.vue": "2470",
	"./IconCancel/index": "5c27",
	"./IconCancel/index.js": "5c27",
	"./IconCheck": "76f7",
	"./IconCheck/": "76f7",
	"./IconCheck/IconCheck": "a698",
	"./IconCheck/IconCheck.vue": "a698",
	"./IconCheck/index": "76f7",
	"./IconCheck/index.js": "76f7",
	"./IconDelete": "5e04",
	"./IconDelete/": "5e04",
	"./IconDelete/IconDelete": "b63f",
	"./IconDelete/IconDelete.vue": "b63f",
	"./IconDelete/index": "5e04",
	"./IconDelete/index.js": "5e04",
	"./IconDownload": "fb8d",
	"./IconDownload/": "fb8d",
	"./IconDownload/IconDownload": "e7af",
	"./IconDownload/IconDownload.vue": "e7af",
	"./IconDownload/index": "fb8d",
	"./IconDownload/index.js": "fb8d",
	"./IconNext": "1f09",
	"./IconNext/": "1f09",
	"./IconNext/IconNext": "6d5b",
	"./IconNext/IconNext.vue": "6d5b",
	"./IconNext/index": "1f09",
	"./IconNext/index.js": "1f09",
	"./IconPlus": "fe8b",
	"./IconPlus/": "fe8b",
	"./IconPlus/IconPlus": "0c32",
	"./IconPlus/IconPlus.vue": "0c32",
	"./IconPlus/index": "fe8b",
	"./IconPlus/index.js": "fe8b",
	"./Iconos-permisos": "dfb8",
	"./Iconos-permisos.json": "dfb8",
	"./Steps/IconCirculeCheck": "04bb",
	"./Steps/IconCirculeCheck/": "04bb",
	"./Steps/IconCirculeCheck/IconCirculeCheck": "fc16",
	"./Steps/IconCirculeCheck/IconCirculeCheck.vue": "fc16",
	"./Steps/IconCirculeCheck/index": "04bb",
	"./Steps/IconCirculeCheck/index.js": "04bb",
	"./Steps/IconCirculeControl": "a785",
	"./Steps/IconCirculeControl/": "a785",
	"./Steps/IconCirculeControl/IconCirculeControl": "10fc",
	"./Steps/IconCirculeControl/IconCirculeControl.vue": "10fc",
	"./Steps/IconCirculeControl/index": "a785",
	"./Steps/IconCirculeControl/index.js": "a785",
	"./Steps/IconCirculeDefendant": "0ab5",
	"./Steps/IconCirculeDefendant/": "0ab5",
	"./Steps/IconCirculeDefendant/IconCirculeDefendant": "2da9",
	"./Steps/IconCirculeDefendant/IconCirculeDefendant.vue": "2da9",
	"./Steps/IconCirculeDefendant/index": "0ab5",
	"./Steps/IconCirculeDefendant/index.js": "0ab5",
	"./Steps/IconCirculeDocument": "fcc8",
	"./Steps/IconCirculeDocument/": "fcc8",
	"./Steps/IconCirculeDocument/IconCirculeDocument": "1750",
	"./Steps/IconCirculeDocument/IconCirculeDocument.vue": "1750",
	"./Steps/IconCirculeDocument/index": "fcc8",
	"./Steps/IconCirculeDocument/index.js": "fcc8",
	"./Steps/IconCirculeRisk": "823e",
	"./Steps/IconCirculeRisk/": "823e",
	"./Steps/IconCirculeRisk/IconCirculeRisk": "4111",
	"./Steps/IconCirculeRisk/IconCirculeRisk.vue": "4111",
	"./Steps/IconCirculeRisk/index": "823e",
	"./Steps/IconCirculeRisk/index.js": "823e",
	"./Steps/IconCirculeUpdate": "87ba",
	"./Steps/IconCirculeUpdate/": "87ba",
	"./Steps/IconCirculeUpdate/IconCirculeUpdate": "e25a",
	"./Steps/IconCirculeUpdate/IconCirculeUpdate.vue": "e25a",
	"./Steps/IconCirculeUpdate/index": "87ba",
	"./Steps/IconCirculeUpdate/index.js": "87ba",
	"./Steps/IconCirculeUser": "3ec8",
	"./Steps/IconCirculeUser/": "3ec8",
	"./Steps/IconCirculeUser/IconCirculeUser": "0f27",
	"./Steps/IconCirculeUser/IconCirculeUser.vue": "0f27",
	"./Steps/IconCirculeUser/index": "3ec8",
	"./Steps/IconCirculeUser/index.js": "3ec8",
	"./accessible.svg": "2ab2",
	"./add.svg": "876b",
	"./airplane.svg": "a96b",
	"./alarm-warning-line.svg": "b28a",
	"./alert-icon.svg": "8939",
	"./alert-line.svg": "533f",
	"./archive.svg": "6e22",
	"./arrow-drop-up-line.svg": "5564",
	"./arrow-select.svg": "c0fd",
	"./attach_money_24px.png": "6fbd",
	"./bar.svg": "07cf",
	"./bar1.svg": "1f93",
	"./bar1Green.svg": "3a7c",
	"./bar2.svg": "e63f",
	"./bar2Green.svg": "114b",
	"./bell.svg": "ec9c",
	"./blue-eye.svg": "9629",
	"./calendar.svg": "6bca",
	"./calendar_green.svg": "0789",
	"./cerrado.svg": "18fb",
	"./check-calendar.svg": "ab65",
	"./check-circle.svg": "f9be",
	"./check.svg": "e7d6",
	"./check_circle_24px.svg": "b5a2",
	"./check_circle_green.svg": "b20b",
	"./checkbox-circle-line.svg": "b276",
	"./chevron-down.svg": "c963",
	"./chevron-up.svg": "ed78",
	"./circle-check.svg": "ac3d",
	"./circle-check2.svg": "3c97",
	"./circle-clock.svg": "586c",
	"./circle-clock2.svg": "39da",
	"./circle-help.svg": "abc5",
	"./circle1.svg": "391a",
	"./circle1Green.svg": "3da4",
	"./circle1GreenBig.svg": "02ef",
	"./circle1ORI.svg": "1afc",
	"./circle2.svg": "b4e4",
	"./circle2Green.svg": "a9d0",
	"./circle3.svg": "72ac",
	"./circle4.svg": "14fd",
	"./circle4green.svg": "e4e0",
	"./circleGreen3.svg": "d018",
	"./circleOrange2.svg": "9613",
	"./circleOrange2b.svg": "0f58",
	"./circleOrange3.svg": "1150",
	"./circleOrange3b.svg": "a7a1",
	"./circleOrange4.svg": "4e61",
	"./circleWhite.svg": "8026",
	"./clip.svg": "886b",
	"./clock_historial.svg": "21b1",
	"./close-circle-line.svg": "c8fc",
	"./close-line.svg": "1c0f",
	"./close.svg": "0572",
	"./close_24px.svg": "bae7",
	"./close_gray.svg": "a1f9",
	"./cloud_upload.svg": "bdd1",
	"./danger_icon.svg": "4a25",
	"./danger_type_modif.svg": "b1c1",
	"./dashboard.svg": "a2db",
	"./delete-bin-2-line.svg": "0599",
	"./delete_trash.svg": "ae9e",
	"./delete_trash_white.svg": "0ced",
	"./deny-red.svg": "759d",
	"./deny.svg": "d0b2",
	"./directions.svg": "1f44",
	"./document.svg": "1344",
	"./download-cloud.svg": "18f2",
	"./download.svg": "0339",
	"./edit-blue.svg": "196e",
	"./edit.svg": "c560",
	"./edit_pencil.svg": "ec1f",
	"./editlist.svg": "c310",
	"./employee.png": "a7ee",
	"./event_seat.svg": "3aa5",
	"./event_seat_2.svg": "ba15",
	"./excel.svg": "6693",
	"./exitWhite.svg": "b0df",
	"./eye-line.png": "f381",
	"./eye-line.svg": "376a",
	"./eye.svg": "0406",
	"./face.svg": "96c1",
	"./filter.svg": "ce2e",
	"./filter_list.svg": "ef90",
	"./filter_list_24px.svg": "8d6c",
	"./flight.svg": "a65f",
	"./footer.svg": "1933",
	"./grafic-pie.png": "ed62",
	"./grafic-pie.svg": "f9d2",
	"./grayBar.svg": "e1d7",
	"./grayBarEnd.svg": "f42b",
	"./greenBall.svg": "7150",
	"./greenBarEnd.svg": "6670",
	"./happy-message.svg": "3eb1",
	"./header.svg": "704a",
	"./healing.svg": "871b",
	"./help_outline.svg": "2389",
	"./history-gray.svg": "7433",
	"./history.svg": "6353",
	"./ht_icon_calendar_line.svg": "59a3",
	"./ht_icon_check.svg": "17c7",
	"./ht_icon_checkbox_circle_line.svg": "66c2",
	"./ht_icon_clock.svg": "a047",
	"./ht_icon_close_circle_line.svg": "0dda",
	"./ht_icon_draft.svg": "8e6e",
	"./ht_icon_edit_v2.svg": "40fb",
	"./ht_icon_eye.svg": "9eb9",
	"./ht_icon_history.svg": "5caf",
	"./ht_icon_modification.svg": "4108",
	"./ht_icon_search_2_line.svg": "c091",
	"./ht_icon_stack.svg": "0e0c",
	"./ht_icon_store_3_line.svg": "8a48",
	"./ht_icon_timelapse_line.svg": "9f93",
	"./ht_icon_upload.svg": "2290",
	"./ht_icon_upload_cloud_2_line.svg": "7ad2",
	"./ht_icon_user.svg": "4ee1",
	"./icon-bell.svg": "851f",
	"./icon-chart-bar.svg": "1846",
	"./icon-danger.svg": "9ae2",
	"./icon-delete-red.svg": "9e57",
	"./icon-document-download.svg": "3e5f",
	"./icon-document-litigio.svg": "5efc",
	"./icon-document.svg": "c88c",
	"./icon-edit.svg": "1eee",
	"./icon-form.svg": "9bb3",
	"./icon-help.svg": "cdec",
	"./icon-information-circle.svg": "a878",
	"./icon-information-fill.svg": "5a0f",
	"./icon-list-document.svg": "d4d8",
	"./icon-mas.svg": "0441",
	"./icon-matriz-iper/eye.png": "b714",
	"./icon-matriz-iper/icon-filter.png": "bb8a",
	"./icon-matriz-iper/icon-left-2.png": "702b",
	"./icon-matriz-iper/icon-left-3.png": "e987",
	"./icon-matriz-iper/icon-left.png": "6f02",
	"./icon-matriz-iper/icon-right.png": "405e",
	"./icon-matriz-iper/icon-warning.png": "53b2",
	"./icon-matriz-iper/plus.png": "d666",
	"./icon-matriz-iper/risk-alto.png": "558f",
	"./icon-matriz-iper/risk-leve.png": "4b71",
	"./icon-matriz-iper/risk-muy-alto.png": "1f22",
	"./icon-matriz-iper/risk-posible.png": "e544",
	"./icon-matriz-iper/risk-sustancial.png": "7d42",
	"./icon-matriz-iper/search.png": "f7f0",
	"./icon-matriz-iper/sin-calification.png": "f4e5",
	"./icon-money.svg": "8ccd",
	"./icon-morbidity/body.svg": "0ab4",
	"./icon-morbidity/bodypart.svg": "d4f8",
	"./icon-morbidity/circle1.png": "2466",
	"./icon-morbidity/circle2.png": "b45a",
	"./icon-morbidity/circle3.png": "9f7a",
	"./icon-morbidity/icon1.png": "5f56",
	"./icon-morbidity/icon10.png": "5fb5",
	"./icon-morbidity/icon11.png": "24fa",
	"./icon-morbidity/icon2.png": "24fe",
	"./icon-morbidity/icon3.png": "3d0c",
	"./icon-morbidity/icon4.png": "9087",
	"./icon-morbidity/icon5.png": "e44a",
	"./icon-morbidity/icon6.png": "5a2e",
	"./icon-morbidity/icon7.png": "1aa6",
	"./icon-morbidity/icon8.png": "92c8",
	"./icon-morbidity/icon9.png": "585d",
	"./icon-pdf.svg": "c2b6",
	"./icon-point.svg": "1a15",
	"./icon-success-litigio.svg": "6cb1",
	"./icon-user.svg": "a26a",
	"./icon-warning-circle.svg": "4cc1",
	"./icon-warning-hex.svg": "07891",
	"./icon_callendar.svg": "89ca",
	"./icon_edit.svg": "b684",
	"./icon_more.svg": "f89f",
	"./icon_mostrar.svg": "9ef6",
	"./icon_plus_round.svg": "1b87",
	"./icon_user.svg": "7f02",
	"./iconfolder.svg": "f18a",
	"./inbox-unarchive-fill.svg": "489f",
	"./info_24px_rounded.png": "3345",
	"./info_type_modif.svg": "be4d",
	"./information-line.svg": "b906",
	"./keyboard_arrow.svg": "469c",
	"./layout-edit.svg": "8b3f",
	"./lightbulb.svg": "99ac",
	"./list_alt.svg": "2b0b",
	"./logo-dp.svg": "82d4",
	"./logo_people_master.svg": "ebb4",
	"./logovp.svg": "5cf8",
	"./logovp3_36x36.svg": "5463",
	"./logovp3_40x40.svg": "4576",
	"./logovp3_LW36.svg": "e9e6",
	"./logovp3_LW40.svg": "a43e",
	"./lupa_buscar.svg": "588d",
	"./mail.svg": "e28e",
	"./master_isotipo_VP.svg": "8c5b",
	"./medic-concepts.svg": "af36",
	"./mobilexpense.svg": "07ff",
	"./notepad-green.svg": "63a6",
	"./notepad.svg": "4c7d",
	"./ocultar_menu.svg": "600a",
	"./open_menu.svg": "2020",
	"./orange-clock.svg": "e53d",
	"./orangeBar.svg": "add0",
	"./orangeBarEnd.svg": "3665",
	"./pendiente.svg": "de2c",
	"./people-white.svg": "2726",
	"./people.svg": "f2de",
	"./permisos-block.svg": "69ea",
	"./phone.svg": "a3f6",
	"./photo.svg": "8152",
	"./pieChart.svg": "8f7f",
	"./print.svg": "9fbb",
	"./push.svg": "31c7",
	"./quitar.svg": "d312",
	"./rechazado.svg": "03e9",
	"./record-circle-line.png": "67a0",
	"./redBall.svg": "1121",
	"./refresh-oclok.png": "4b0c",
	"./riesgobajo.svg": "f96e",
	"./sam.svg": "4ab6",
	"./save-white.svg": "0995",
	"./save.svg": "077b",
	"./saveWhite.svg": "7cd0",
	"./search.svg": "f919",
	"./security.svg": "2e38",
	"./see.svg": "8dc9",
	"./select-category-stadistics.svg": "4a09",
	"./sello-adbid.pdf": "5c43",
	"./sendM.svg": "6c80",
	"./stethoscope.svg": "be87",
	"./success_type_modif.svg": "84d8",
	"./sve.svg": "f0ce",
	"./table-edit.svg": "5153",
	"./table.svg": "1bc9",
	"./tiempos.PNG": "bbfc",
	"./tiempos2.JPG": "b7de",
	"./tiempos2.PNG": "248d",
	"./timelapse.svg": "f5b3",
	"./timelapse_green.svg": "1463",
	"./trash.svg": "a3e6",
	"./up.svg": "6156",
	"./upWhite.svg": "cafc",
	"./upheader.svg": "3ed2",
	"./upload-cloud-2-line.svg": "bec6",
	"./upload.svg": "a13b",
	"./user-2-line.svg": "45d5",
	"./user-check.svg": "5db3",
	"./vector-seacrh-filter.svg": "6515",
	"./wait-clock.svg": "fc4c",
	"./warning-blue.svg": "bdbe",
	"./warning.svg": "080e",
	"./warning_.svg": "476f",
	"./warning_orange.svg": "6650",
	"./warning_red.svg": "9726",
	"./warning_yellow.svg": "4401",
	"./weight.svg": "88b1"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0075";